// Central content + shared constants for the LadyArt site.

export const WHATSAPP =
    "https://wa.me/40755460397?text=" +
    encodeURIComponent(
        "Bună ziua! Aș dori să fac o programare la LadyArt.",
    );

export const PHONE_DISPLAY = "0755 460 397";
export const PHONE_TEL = "tel:+40755460397";

export const INSTAGRAM = "https://www.instagram.com/lladyart/";
export const FACEBOOK = "https://www.facebook.com/ladyartfalticeni";
export const ANPC_URL = "https://anpc.ro/";
export const SAL_URL = "https://anpc.ro/ce-este-sal/";
export const SOL_URL = "https://ec.europa.eu/consumers/odr/";
export const DEV_WHATSAPP = "https://wa.me/40754482899";
export const DEV_TEL = "tel:+40754482899";

export const ADDRESS = "Strada Sucevei 84A, 725200 Fălticeni";
export const MAPS_URL =
    "https://www.google.com/maps/search/?api=1&query=Strada+Sucevei+84A+F%C4%83lticeni";
export const MAPS_EMBED =
    "https://www.google.com/maps?q=Strada%20Sucevei%2084A%2C%20F%C4%83lticeni&output=embed";

export const HOURS = [
    { day: "Luni — Sâmbătă", time: "09:00 — 17:00" },
    { day: "Duminică", time: "Închis" },
];

export const NAV_LEFT = [
    { label: "Servicii", href: "#servicii" },
    { label: "Portofoliu", href: "#portofoliu" },
];
export const NAV_RIGHT = [
    { label: "Experiența", href: "#experienta" },
    { label: "Salonul", href: "#salon" },
];

export const SERVICES = [
    {
        n: "01",
        title: "AirTouch",
        img: "/photos/airtouch.webp",
        desc: "Tranziții de blond construite fir cu fir, pentru o lumină naturală care crește frumos.",
    },
    {
        n: "02",
        title: "Balayage",
        img: "/photos/balayage.webp",
        desc: "Pictură manuală de culoare, dimensiune caldă și rădăcini care nu cer întreținere strictă.",
    },
    {
        n: "03",
        title: "Corecție de culoare",
        img: "/photos/img4.webp",
        desc: "Readucem părul la nuanța dorită, cu grijă pentru sănătatea firului și un rezultat curat.",
    },
    {
        n: "04",
        title: "Styling",
        img: "/photos/img8.webp",
        desc: "Coafuri de eveniment și volum editorial, finisate pentru fotografii și pentru viața reală.",
    },
];

export const PORTFOLIO = [
    { img: "/photos/img12.webp", tall: true },
    { img: "/photos/img1.webp", tall: false },
    { img: "/photos/img11.webp", tall: false },
    { img: "/photos/img6.webp", tall: true },
    { img: "/photos/img5.webp", tall: false },
    { img: "/photos/img9.webp", tall: false },
];

export const STEPS = [
    {
        n: "01",
        title: "Consultație",
        desc: "Discutăm despre ceea ce îți dorești și despre posibilitățile părului tău.",
    },
    {
        n: "02",
        title: "Plan",
        desc: "Alegem împreună tehnica și nuanțele potrivite.",
    },
    {
        n: "03",
        title: "Transformare",
        desc: "Realizăm transformarea cu tehnica aleasă și produse profesionale.",
    },
    {
        n: "04",
        title: "Recomandări",
        desc: "Primești recomandări pentru întreținerea rezultatului acasă.",
    },
];

export const MARQUEE = [
    "Balayage",
    "AirTouch",
    "Corecție de culoare",
    "Styling",
    "Blond rece",
    "Îngrijire",
];

export const HIGHLIGHTS = [
    "AirTouch",
    "Balayage",
    "Corecție de culoare",
    "Styling",
];

export const STATS = [
    { value: "8", suffix: "+", label: "ANI DEDICAȚI FRUMUSEȚII" },
    { value: "100", suffix: "%", label: "Satisfacție client" },
    { value: "100", suffix: "%", label: "Produse profesionale" },
];

export const GOOGLE_REVIEWS =
    "https://www.google.com/maps/search/LadyArt+F%C4%83lticeni";

export const REVIEWS = [
    {
        quote:
            "Personalul este foarte amabil, atmosfera plăcută iar rezultatele sunt conform așteptărilor mereu! Recomand cu drag acest salon tuturor celor care caută profesionalism și servicii de calitate!",
        name: "Elena-Vasilica Ciotina",
    },
    {
        quote:
            "Pur și simplu le ador! Au mâini de aur și mereu știu ce mi se potrivește. În plus, atmosfera este relaxată și plină de voie bună – te simți ca între prieteni! Dacă vrei o coafură perfectă și o experiență plăcută, ele sunt alegerea ideală!",
        name: "Florina Basarabie",
    },
    {
        quote:
            "Pentru mine întotdeauna este o experiență excelentă la LadyArt! Fetele sunt foarte profesioniste, atente la detalii și extrem de prietenoase. Se simte pasiunea și grija pentru fiecare clientă. Recomand cu mare drag acest salon tuturor femeilor și fetelor care își doresc servicii de calitate și un look impecabil!",
        name: "Maria Luca",
    },
];
